module.exports = Promise.all([__parcel__import__("hsljJ"), __parcel__import__("4TUDs")]).then(() => parcelRequire('4qady'));